import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './plugins/ElementUi'
import './plugins/Filters'
import './plugins/Components'
import i18n from './plugins/i18n'
import './mixins';
import './assets/styles/styles.scss';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
